import { Tooltip } from '@mui/material';
import { ReactComponent as IconPremium } from "assets/icon_premium.svg";
import { AppAction, AppContext } from "helpers/context";
import { useContext } from "react";
import { useTranslation } from "react-i18next";

interface Props {
    style?: React.CSSProperties;
    className?: string;
}

function FathomIcon(props: Props) {

    const [context, dispatch] = useContext(AppContext);
    const [t] = useTranslation();

    const handleClick = (event: any) => {
        event.preventDefault();
        dispatch({ type: AppAction.setFathomIconDialog, payload: true });
    }

    return (<>
        <Tooltip title={t("layers.fathomFeeReminder")} placement="top">
            <IconPremium style={props.style} className={props.className} onClick={handleClick} />
        </Tooltip>
    </>);
}

export default FathomIcon;